module.exports = new __parcel__URL__("map-marker-red.594f507d.svg").toString();